import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import TrafficSourcesListTab from './TrafficSourcesListTab';
import FlowsListTab from '../flows/FlowsListTab';

const SHARED_PARAMS = ['q', 'tags', 'page', 'status', 'network'];

export default function TrafficSourcesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'traffic-sources';

  const onTabChange = (_: React.SyntheticEvent, v: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      SHARED_PARAMS.forEach((k) => next.delete(k));
      next.set('tab', v);
      return next;
    }, { replace: true });
  };

  return (
    <Box>
      <Typography variant="h4" fontWeight={600} sx={{ mb: 2 }}>Traffic Sources</Typography>
      <Tabs value={tab} onChange={onTabChange} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Traffic Sources" value="traffic-sources" />
        <Tab label="Flows" value="flows" />
      </Tabs>
      {tab === 'flows' ? <FlowsListTab /> : <TrafficSourcesListTab />}
    </Box>
  );
}
